import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import AppBar from "./Common/AppBar";
import Drawer from "./Common/Drawer";
import Copyright from "./Common/Copyright";
import Chart from "./Dashboard/Chart";
import SessionList from "./Sessions/SessionList";
import ValueBox from "./Dashboard/ValueBox";

// TODO remove, this demo shouldn"t need to reset the theme.
const defaultTheme = createTheme();

const Sessions = ({ token }) => {
  const [open, setOpen] = React.useState(false);
  const toggleDrawer = () => {
    setOpen(!open);
  };

  const [CountSessionsActive, setCountSessionsActive] = React.useState()
  const [CountSessionsTotal, setCountSessionsTotal] = React.useState()

  const updateCountSessions = async () => {
    fetch(`${process.env.REACT_APP_API_URL}/stats/sessions/active`, 
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Token": token
            }
        }
    )
    .then((response) => response.json())
    .then((data) => {
        setCountSessionsActive(data.count)
    }).catch((error) => console.error("Error fetching active sessions count:", error));
  
    fetch(`${process.env.REACT_APP_API_URL}/stats/sessions/total`, 
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Token": token
            }
        }
    )
    .then((response) => response.json())
    .then((data) => {
        setCountSessionsTotal(data.count)
    }).catch((error) => console.error("Error fetching total sessions count:", error));
  }
  
  React.useEffect(() => {
      updateCountSessions();
  });

  return (
    <ThemeProvider theme={defaultTheme}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar open={open} toggleDrawer={toggleDrawer} />
        <Drawer open={open} toggleDrawer={toggleDrawer} />
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === "light"
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: "100vh",
            overflow: "auto",
          }}
        >
          <Toolbar />
          <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Grid container spacing={3}>
              {/* Recent Orders */}
              <Grid item xs={12}>
                <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
                  <SessionList token={ token } />
                </Paper>
              </Grid>
            </Grid>
            <Copyright sx={{ pt: 4 }} />
          </Container>
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default Sessions;